import React from 'react';

import loader from '../../assets/loading.svg';

import { Overlay } from './styles';

const Loading: React.FC = () => {
  return (
    <Overlay>
      <img src={loader} alt="Carregando..." />
    </Overlay>
  );
};

export default Loading;
